import setMaterial from "./setMaterial";

function enableMaterial(materialsArray: string[], materialSpans: NodeListOf<HTMLSpanElement>) {
	for (const material of materialsArray) {
		setMaterial(material, materialSpans);
	}
}

export default enableMaterial;
